import { render, staticRenderFns } from "./UploadApk.vue?vue&type=template&id=06d1ac3e&scoped=true&"
import script from "./UploadApk.vue?vue&type=script&lang=js&"
export * from "./UploadApk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1ac3e",
  null
  
)

export default component.exports